import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { SubscriptionProvider } from "./components/SubscriptionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SubscriptionProvider>
      <App />
    </SubscriptionProvider>
  </Provider>
);
